import React from 'react';
import { usePolTranslation } from "v4/hooks/usePolTranslation";

export default function PennylaneConfirmUpdate() {
    const { t } = usePolTranslation();

    return (
        <>
            <p>{t('pennylane_update_confirm_intro')}</p>
            <p>{t('pennylane_update_confirm_warning')}</p>
        </>
    );
}
